module.exports = __webpack_public_path__ + "img/mission_check_icon.a9d0dcd2.svg";